import { Text, useBreakpointValue } from "@chakra-ui/react";
import { useMemo } from "react";

export const ViewSectionFees = (props) => {
  const { profile } = props;

  const decodedText = useMemo(() => {
    const isServer = typeof window === "undefined";
    if (isServer) {
      return profile.feeStructure;
    }
    const decodeElement = document.createElement("div");
    let text = profile.feeStructure;

    if (text && typeof text === "string") {
      text = text.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
      text = text.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
      decodeElement.innerHTML = text;
      text = decodeElement.textContent;
      decodeElement.textContent = "";
    }

    return text;
  }, [profile]);

  return (
    <div className="relative flex flex-col p-[30px] gap-5">
      <div>
        <Text textStyle="h3">Fees</Text>
        <div className="flex items-center">
          <p className="mr-2 text-sm text-brand-alt">Average session fee:</p>
          <p className="font-bold text-sm text-brand-alt">
            {profile.averagePrice
              ? `£${profile.averagePrice.toFixed(2)}`
              : "No information"}
          </p>
        </div>
      </div>
      <div>
        <p className="font-bold pb-2">Fee structure</p>
        {profile.feeStructure && profile.feeStructure.length > 0 ? (
          <p
            className="p-3 rounded-[10px] bg-brand-off text-brand-alt"
            style={{ whiteSpace: "pre-line" }}
          >
            {decodedText}
          </p>
        ) : (
          <p className="text-brand-alt">No fee structure provided</p>
        )}
      </div>
    </div>
  );
};
